import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, Fun, Pair, mk_pair, Options, mk_widget } from "../widget";

export interface TransformProps<i1,o1,i2,o2> {
  input:i2
  input_transform:Fun<i2,i1>
  inner_widget:IOWidget<i1,o1>
  output_transform:Fun<o1,o2>
  on_done_transform:(output:o2) => void
}
export interface TransformState<i1,o1,i2,o2> {
  value1:o1 | null
  value2:o2 | null
}
export class Transform<i1,o1,i2,o2> extends React.Component<TransformProps<i1,o1,i2,o2>, TransformState<i1,o1,i2,o2>> {
  constructor(props:TransformProps<i1,o1,i2,o2>, context:any) {
    super(props, context)

    this.state = { value1:null, value2:null }
  }

  render() {
    return this.props.inner_widget(this.props.input_transform(this.props.input)).run(output1 =>
        this.props.on_done_transform(this.props.output_transform(output1)))
  }
}

export let transform = function<i1,o1,i2,o2>(input_transform:Fun<i2,i1>, inner_widget:IOWidget<i1,o1>, output_transform:Fun<o1,o2>) :
  IOWidget<i2,o2> {
  return (input:i2) => mk_widget({
    run:(on_done_transform:(output:o2) => void) =>
      React.createElement<TransformProps<i1,o1,i2,o2>>(Transform, { on_done_transform, inner_widget, input, input_transform, output_transform })
  })
}
